import React from 'react';
import styled from 'styled-components';
import { translate } from '../../../../common/translation/translate';
import { CardDetailLabels } from '../../common/types';
import { CardDetailsItem } from './cardDetailsItem';

const CardDetailLabelsMobile = {
    ...CardDetailLabels,
    feelsLike: 'feelsLike'
} as const;

const mobileHourlyCardDetailItemKey = 'mobile-hourly-forecast-card-detail-item';

type CardDetailLabelTypes = keyof typeof CardDetailLabelsMobile;

type HourCardDetailsProps = {
    [key in CardDetailLabelTypes]: string;
}

export const HourCardDetails = ({ humidity, wind, dewPoint, feelsLike }: HourCardDetailsProps) => {
    return (
        <Container>
            <DetailsList key='mobile-hourly-forecast-card-list'>
                <CardDetailsItem
                    key={`${mobileHourlyCardDetailItemKey}${CardDetailLabelsMobile.wind}`}
                    itemLabel={wind}
                    itemValue={translate(CardDetailLabelsMobile.wind)} />
                <CardDetailsItem
                    key={`${mobileHourlyCardDetailItemKey}${CardDetailLabelsMobile.dewPoint}`}
                    itemLabel={dewPoint}
                    itemValue={translate(CardDetailLabelsMobile.dewPoint)} />
                <CardDetailsItem
                    key={`${mobileHourlyCardDetailItemKey}${CardDetailLabelsMobile.humidity}`}
                    itemLabel={humidity}
                    itemValue={translate(CardDetailLabelsMobile.humidity)} />
                <CardDetailsItem
                    key={`${mobileHourlyCardDetailItemKey}${CardDetailLabelsMobile.feelsLike}`}
                    itemLabel={feelsLike}
                    itemValue={translate(CardDetailLabelsMobile.feelsLike)} />
            </DetailsList>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 56px;
    background-color: #eee;
    border-bottom-right-radius: 2px;
    border-bottom-left-radius: 2px;
`;

const DetailsList = styled.ul`
    display: flex;
    flex-direction: row;
    width: 100%;
    font-size: 0;
    white-space: nowrap;
    padding: 10px;
    list-style-type: none;
`;
